module.exports = __webpack_public_path__ + "img/exampleCompress.f4374d08.jpeg";